import { FC, useMemo } from 'react';
import { HeroConversationMessage, ConversationMessageType } from '@vs-online-only-app/state';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { Check, Block } from '@mui/icons-material';

type Props = {
  message: HeroConversationMessage;
};

const ContactOptedInOutMessage: FC<Props> = ({ message }) => {

  const { attributes } = message;
  const type = attributes?.type;
  const optIn = useMemo(() => type === ConversationMessageType.ContactsOptIn, [type]);
  
  const messageBody = useMemo(() => {
    return `User has opted ${optIn ? 'in' : 'out'}.`;
  }, [optIn]);

  return (
    <>
      <Box minHeight={(theme) => theme.spacing(2)} />
      <Stack alignItems="center">
        <Chip
          label={
            <Stack direction="row" gap={1}>
              {optIn ? <Check fontSize="small" /> : <Block fontSize="small" />}
              <Typography variant="body2" color="textSecondary">
                {messageBody}
              </Typography>
            </Stack>
          }
        />
      </Stack>
      <Box minHeight={(theme) => theme.spacing(2)} />
    </>
  );
};

export default ContactOptedInOutMessage;
